<template>
  <Layout>
    <div class="reports-hub">
      <div class="reports-grid">
        <router-link
          v-for="card in reportCards"
          :key="card.path"
          :to="card.path"
          class="reports-card"
          :class="card.tone"
        >
          <div class="reports-card-head">
            <span class="reports-card-kicker">{{ card.kicker }}</span>
            <span class="reports-card-arrow">Abrir</span>
          </div>
          <div class="reports-card-title">{{ card.title }}</div>
          <div class="reports-card-description">{{ card.description }}</div>
          <div class="reports-card-footer">
            <span>{{ card.badge }}</span>
          </div>
        </router-link>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@layouts/main'

export default {
  components: {
    Layout,
  },
  data() {
    return {
      reportCards: [
        {
          title: 'São Paulo - CREA',
          description: 'Gere o relatório para enviar ao CREA de São Paulo.',
          path: '/register/rel-creasp',
          kicker: 'Relatório',
          badge: 'Fluxo CREA',
          tone: 'tone-ocean',
        },
        {
          title: 'Rio Grande do Sul - SIG@',
          description: 'Gere o relatório para enviar ao SIG@.',
          path: '/register/rel-siga',
          kicker: 'Relatório',
          badge: 'Fluxo SIGA',
          tone: 'tone-sand',
        },
        {
          title: 'Bahia - ADAB',
          description: 'Gere o relatório para enviar a ADAB.',
          path: '/register/rel-adab',
          kicker: 'Relatório',
          badge: 'Fluxo ADAB',
          tone: 'tone-forest',
        },
        {
          title: 'Paraná - SIAGRO',
          description: 'Gere o relatório para enviar ao SIAGRO.',
          path: '/register/rel-siagro',
          kicker: 'Relatório',
          badge: 'Fluxo SIAGRO',
          tone: 'tone-plum',
        },
        {
          title: 'Minas Gerais - IMA',
          description: 'Gere o relatório para enviar ao IMA.',
          path: '/register/rel-ima',
          kicker: 'Relatório',
          badge: 'Fluxo IMA',
          tone: 'tone-slate',
        },
        {
          title: 'Santa Catarina - SIGEN+',
          description: 'Gere o relatório para enviar ao SIGEN+.',
          path: '/register/rel-singen',
          kicker: 'Relatório',
          badge: 'Fluxo SIGEN',
          tone: 'tone-forest',
        },
        {
          title: 'Mato Grosso - INDEA',
          description: 'Gere o relatório para enviar ao INDEA.',
          path: '/register/rel-indea',
          kicker: 'Relatório',
          badge: 'Fluxo INDEA',
          tone: 'tone-ocean',
        },
        {
          title: 'Goias - Agrodefesa',
          description: 'Gere o relatório para enviar ao Agrodefesa.',
          path: '/register/rel-agrodefesa',
          kicker: 'Relatório',
          badge: 'Fluxo SIGEA',
          tone: 'tone-sand',
        },
        {
          title: 'CFTA',
          description: 'Gere o relatório para enviar ao CFTA.',
          path: '/register/rel-cfta',
          kicker: 'Relatório',
          badge: 'Fluxo CFTA',
          tone: 'tone-slate',
        },
        {
          title: 'Receitas Emitidas',
          description: 'Exporte em Excel a listagem de receitas emitidas por período.',
          path: '/register/rel-receitas-emitidas',
          kicker: 'Relatório',
          badge: 'Excel Receitas',
          tone: 'tone-ocean',
        },
        {
          title: 'Logs e Monitoramento',
          description: 'Acompanhe os processos de integracao e o historico de eventos por ambiente.',
          path: '/register/integracoes-painel',
          kicker: 'Monitoramento',
          badge: 'Painel de integracoes',
          tone: 'tone-plum',
        },
      ],
    }
  },
}
</script>

<style scoped>
.reports-hub {
  padding: 24px;
}

.reports-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.reports-card {
  display: flex;
  flex-direction: column;
  min-height: 200px;
  padding: 20px;
  border-radius: 22px;
  border: 1px solid #dce8e3;
  text-decoration: none;
  background: #ffffff;
  box-shadow: 0 16px 34px rgba(15, 46, 39, 0.07);
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.reports-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 22px 42px rgba(15, 46, 39, 0.12);
  text-decoration: none;
}

.reports-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.reports-card-kicker {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.reports-card-arrow {
  font-size: 12px;
  font-weight: 700;
  opacity: 0.82;
}

.reports-card-title {
  color: #153b33;
  font-size: 22px;
  font-weight: 800;
  line-height: 1.18;
}

.reports-card-description {
  margin-top: 12px;
  color: #5e726c;
  font-size: 14px;
  line-height: 1.65;
  flex: 1;
}

.reports-card-footer {
  margin-top: 18px;
  color: #0e6453;
  font-size: 12px;
  font-weight: 700;
}

.tone-ocean {
  background: linear-gradient(180deg, #ffffff 0%, #f1f8f9 100%);
}

.tone-ocean .reports-card-kicker,
.tone-ocean .reports-card-arrow,
.tone-ocean .reports-card-footer {
  color: #0d7487;
}

.tone-sand {
  background: linear-gradient(180deg, #ffffff 0%, #fbf7ef 100%);
}

.tone-sand .reports-card-kicker,
.tone-sand .reports-card-arrow,
.tone-sand .reports-card-footer {
  color: #9a6b1f;
}

.tone-forest {
  background: linear-gradient(180deg, #ffffff 0%, #f2faf6 100%);
}

.tone-forest .reports-card-kicker,
.tone-forest .reports-card-arrow,
.tone-forest .reports-card-footer {
  color: #0b7a64;
}

.tone-plum {
  background: linear-gradient(180deg, #ffffff 0%, #f7f2f7 100%);
}

.tone-plum .reports-card-kicker,
.tone-plum .reports-card-arrow,
.tone-plum .reports-card-footer {
  color: #7a406c;
}

.tone-slate {
  background: linear-gradient(180deg, #ffffff 0%, #f2f5f7 100%);
}

.tone-slate .reports-card-kicker,
.tone-slate .reports-card-arrow,
.tone-slate .reports-card-footer {
  color: #46606c;
}

@media (max-width: 1199px) {
  .reports-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 991px) {
  .reports-hub {
    padding: 16px;
  }
}

@media (max-width: 767px) {
  .reports-grid {
    grid-template-columns: 1fr;
  }
}
</style>
